import { Modal } from 'bootstrap';
import React, { forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react';
import DatePicker from "react-datepicker";
import uuid from 'react-uuid';
import { useSelector } from 'react-redux';
import { toast } from "react-toastify";
import Loader from '../../../components/ui/Loader/Loader';
import DateService from '../../../services/DateService';
import HttpAPICall from '../../../services/HttpAPICall';
import { IAM_API_BASE_URL_2, IAM_COUNTERLOG_URL } from '../../../services/TapApiUrls';
import TapIcon from '../../../services/TapIcon';
import DataService from '../../../services/DataService';
import TapHelper from '../../../services/TapHelper';
import moment from 'moment';
import swal from "sweetalert";
import ScsExecutionHistoryView from '../scsExecutionHistory/ScsExecutionHistoryView';

const ExecutedServiceChecksheetDetail = forwardRef((props, ref) => {
    const [scsModalId, setScsModalId] = useState(uuid());
    const scsModalElem = useRef(null);
    const scsModal = useRef(null);
    
    // Second modal for service checksheet detail
    const [serviceModalId, setServiceModalId] = useState(uuid());
    const serviceModalElem = useRef(null);
    const serviceModal = useRef(null);
    
    const scsModalOpen = () => scsModal.current && scsModal.current.show();
    const scsModalClose = () => scsModal.current && scsModal.current.hide();
    
    const serviceModalOpen = () => serviceModal.current && serviceModal.current.show();
    const serviceModalClose = () => serviceModal.current && serviceModal.current.hide();
    
    useEffect(() => {
        // First modal init
        scsModalElem.current = document.getElementById(scsModalId);
        scsModal.current = new Modal(scsModalElem.current, { keyboard: false, backdrop: false });
        
        // Second modal init
        serviceModalElem.current = document.getElementById(serviceModalId);
        serviceModal.current = new Modal(serviceModalElem.current, { keyboard: false, backdrop: false });
        
        return () => {
            scsModal.current && scsModal.current.dispose();
            serviceModal.current && serviceModal.current.dispose();
        };
    }, []);
   
    const access_token = useSelector(state => state.auth.access_token);
    const [executionData, setExecutionData] = useState(null);
    const [viewLoading, setViewLoading] = useState(false);
    
    const [serviceChecksheetData, setServiceChecksheetData] = useState(null);
    const [serviceLoading, setServiceLoading] = useState(false);

    useImperativeHandle(ref, () => ({
        scsDetaildata: (id) => {
            if (id) { openScsModalHandler(id) }
        },
        serviceChecksheetModalInit: () => {
            serviceModalOpen()
        },
    }));

    const openScsModalHandler = (id) => {
        scsModalOpen();
        getExecutionHistoryData(id);
    };
    
    const getExecutionHistoryData = (id) => {
        setViewLoading(true);
        HttpAPICall.withAthorization('GET', IAM_API_BASE_URL_2 + '/scs/execution_detail/' + id, access_token, {}, {}, (resp) => {
            let respData = resp;
            setExecutionData(respData.data);
        }).finally(() => setViewLoading(false));
    };
    

    return (
        <>
            <div className="modal fade" id={scsModalId} tabIndex="-1" ref={scsModalElem}>
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="fs-6 m-0">
                                <span>View Service Checksheet for: </span>
                                {executionData ? DateService.dateTimeFormat(executionData?.feed_datetime) : null}
                            </h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body py-0">
                            {viewLoading ? <Loader />
                                : executionData ? <ScsExecutionHistoryView executionData={executionData} /> : null}
                        </div>
                        <div className="border-top p-2">
                            <div className='text-end'>
                                <button type="button" className="btn btn-secondary me-2" onClick={scsModalClose}>Close</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
            {/* Second Modal - Service Checksheet Detail */}
            <div className="modal fade" id={serviceModalId} tabIndex="-1" ref={serviceModalElem}>
                <div className="modal-dialog modal-lg modal-dialog-scrollable">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="fs-6 m-0">
                                <span>Service Checksheet Details</span>
                            </h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={serviceModalClose}></button>
                        </div>
                        <div className="modal-body">
                            {serviceLoading ? <Loader /> : "gfhgf"}
                        </div>
                        <div className="border-top p-2">
                            <div className='text-end'>
                                <button type="button" className="btn btn-secondary" onClick={serviceModalClose}>Close</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
});

export default ExecutedServiceChecksheetDetail;